import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { themeV2 as theme } from '../../../../themeV2';

const capsSharedStyles = css`
  font-family: ${theme.fonts.main};
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  font-feature-settings: 'ss04' on, 'cv03' on, 'cv04' on;
`;

const CapsLG = css`
  ${capsSharedStyles};
  font-size: 16px;
  line-height: 24px;
`;

const ButtonTextLG = css`
  font-weight: ${theme.fonts.fontWeightSemibold};
  font-family: ${theme.fonts.main};
  letter-spacing: -0.01em;
  font-feature-settings: 'ss04' on, 'cv10' on, 'cv03' on, 'cv04' on;
  font-size: 20px;
  line-height: 24px;
`;
const ParagraphLG = css`
  font-weight: ${theme.fonts.fontWeightRegular};
  font-family: ${theme.fonts.main};
  font-feature-settings: 'pnum' on, 'lnum' on, 'ss04' on, 'cv10' on, 'cv03' on, 'cv04' on;
  font-size: 20px;
  line-height: 24px;
`;

const Heading4 = css`
  font-weight: ${theme.fonts.fontWeightExtrabold};
  letter-spacing: -0.01em;
  font-family: ${theme.fonts.main};
  font-feature-settings: 'ss04' on, 'cv10' on, 'cv03' on, 'cv04' on;
  font-size: 20px;
  line-height: 21px;
`;
export const SuggestionContainer: ReturnType<typeof styled.div> = styled.div`
  ${ParagraphLG};
`;

export const SuggestionHeader: ReturnType<typeof styled.h4> = styled.h4`
  margin-bottom: 30px;
  ${Heading4};
  color: ${theme.colors.lightest};
`;

export const SuggestionText: ReturnType<typeof styled.p> = styled.p`
  ${ParagraphLG};
  color: ${theme.colors.white75};
`;

export const SuggestionCode: ReturnType<typeof styled.p> = styled.p`
  margin-top: 45px;
  ${CapsLG};
  font-weight: ${theme.fonts.fontWeightSemibold};
  color: ${theme.colors.white75};
  letter-spacing: 0.07em;
`;

export const Link: ReturnType<typeof styled.a> = styled.a`
  ${ButtonTextLG};
  color: ${theme.colors.blue400};
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
`;
